// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"06cfef0d","304":"cd8065c7","656":"06dfa347","673":"8f1f6107"}[chunkId] + ".chunk.js";
};